module.exports = __webpack_public_path__ + "img/four-three.63906826.png";